/**
 * File path patterns and storage constants used throughout the application.
 * These constants ensure consistency in file path generation and storage operations.
 */
// Storage bucket names
export const STORAGE_BUCKETS = {
    CHARACTER_IMAGES: 'character-images',
    STYLE_IMAGES: 'style-images',
    GENERATED_STORIES: 'generated-stories',
    STORY_TEMPLATES: 'story-templates',
    PRINT_PDFS: 'print-pdfs',
};
// Signed URL expiration times (in seconds)
export const SIGNED_URL_EXPIRATION = {
    SHORT: 600, // 10 minutes - for upload operations
    STANDARD: 3600, // 1 hour - for general access
};
// Character file path patterns
export const CHARACTER_FILE_PATTERNS = {
    // Reference images: {userId}/{characterId}/reference-images/{imageId}.{extension}
    REFERENCE_IMAGE_PATH: (userId, characterId, imageId, extension) => `${userId}/${characterId}/reference-images/${imageId}.${extension}`,
    // Character sheets: {userId}/{characterId}/character-sheets/{imageId}.{extension}
    CHARACTER_SHEET_PATH: (userId, characterId, imageId, extension) => `${userId}/${characterId}/character-sheets/${imageId}.${extension}`,
    // Character previews: {userId}/{characterId}/character-previews/{styleTemplateId}/{imageId}.{extension}
    CHARACTER_PREVIEW_IMAGE_PATH: (userId, characterId, styleTemplateId, imageId, extension) => `${userId}/${characterId}/character-previews/${styleTemplateId}/${imageId}.${extension}`,
    // Directory patterns for listing files
    REFERENCE_IMAGES_DIR: (userId, characterId) => `${userId}/${characterId}/reference-images`,
    CHARACTER_SHEETS_DIR: (userId, characterId) => `${userId}/${characterId}/character-sheets`,
    CHARACTER_PREVIEWS_DIR: (userId, characterId, styleTemplateId) => `${userId}/${characterId}/character-previews/${styleTemplateId}`,
};
// Style template file path patterns
export const STYLE_TEMPLATE_FILE_PATTERNS = {
    // Style template images: {styleTemplateId}/{imageId}.{extension}
    IMAGE_PATH: (styleTemplateId, imageId, extension) => `${styleTemplateId}/${imageId}.${extension}`,
    // Directory pattern for listing files
    IMAGES_DIR: (styleTemplateId) => `${styleTemplateId}`,
};
// Story template file path patterns
export const STORY_TEMPLATE_FILE_PATTERNS = {
    // Story template cover images: {storyTemplateId}/{imageId}.{extension}
    COVER_IMAGE_PATH: (storyTemplateId, imageId, extension) => `${storyTemplateId}/${imageId}.${extension}`,
    // Directory pattern for listing files
    COVER_IMAGES_DIR: (storyTemplateId) => `${storyTemplateId}`,
};
// Generated stories file path patterns
export const GENERATED_STORIES_FILE_PATTERNS = {
    // Directory patterns for listing files
    COVER_IMAGES_DIR: (userId, storyId) => `${userId}/${storyId}/cover`,
    SPREADS_DIR: (userId, storyId) => `${userId}/${storyId}/spreads`,
    // Cover images: {userId}/{storyId}/cover/{imageId}.{extension}
    COVER_IMAGE_PATH: (userId, storyId, imageId, extension) => `${GENERATED_STORIES_FILE_PATTERNS.COVER_IMAGES_DIR(userId, storyId)}/${imageId}.${extension}`,
    // Spread images: {userId}/{storyId}/spreads/{spreadNum}/{imageId}.{extension}
    SPREAD_IMAGE_PATH: (userId, storyId, spreadNum, imageId, extension) => `${GENERATED_STORIES_FILE_PATTERNS.SPREADS_DIR(userId, storyId)}/${spreadNum}/${imageId}.${extension}`,
};
// Print PDFs file path patterns
export const PRINT_PDFS_FILE_PATTERNS = {
    // Directory: {userId}/{storyId}/
    STORY_DIR: (userId, storyId) => `${userId}/${storyId}`,
    // File path: {userId}/{storyId}/{storyId}-book.pdf
    STORY_PDF_PATH: (userId, storyId) => `${PRINT_PDFS_FILE_PATTERNS.STORY_DIR(userId, storyId)}/${storyId}-book.pdf`,
};
